<template>
    <div class="sidebar-box">
        <van-tabbar route :fixed="false" active-color="#2F54EB" inactive-color="#111111">
            <van-tabbar-item replace to="/" >项目介绍</van-tabbar-item>
            <van-tabbar-item replace to="/microLecture">创业微课</van-tabbar-item>
        </van-tabbar>
    </div>
</template>

<script>
export default {
    name: 'sidebar'
}
</script>

<style lang="scss" scoped>
.sidebar-box{
    border-top: 1px solid #E5E5E5;
    display: flex;
    align-items: center;
    background-color: #fff;
    .van-tabbar{
        height: 84px;
        &::after{
            border-width: 0;
        }
        .van-tabbar-item{
            position: relative;
            font-size: 32px;
        }
        .van-tabbar-item--active{
            &::after{
                content: "";
                position: absolute;
                width: 96px;
                height: 4px;
                background-color: #2F54EB;
                bottom: 0;
                left: 0;
                right: 0;
                margin: auto;
            }
        }
    }
}
</style>
